export enum Themes {
  system = 'system',
  dark = 'dark',
  light = 'light',
}

// Эффективная палитра без `system` — то, что реально подставляется в UI.
export type ThemePalette = 'light' | 'dark'

export enum ConfigStatus {
  loaded,
  loading,
  failed,
}
